import React, { Component, Fragment } from "react";
import AppContext from "../../../contexts/AppContext";
import Header from "./Header";
import { NavLink } from "react-router-dom";
import AccountNav from "./AccountNav";
import ProfileSettings from "../settings/ProfileSettings";

class Portfolio extends Component {
    
	state = {
		managePortfolio : true,
		myBadges : false,
		portfolioVisitor : false,
	};

	// handleMenu = field => {
	// 	if(field == 'managePortfolio')
	// 	{
	// 		this.setState({myBadges : false, earnedBadges : false, reqBadges : false, managePortfolio : true, portfolioVisitor : false});
	// 	}
	// 	if(field == 'myBadges')
	// 	{
	// 		this.setState({myBadges : true, earnedBadges : false, reqBadges : false,  managePortfolio : false, portfolioVisitor : false});
	// 	}
	// 	if(field == 'portfolioVisitor')
	// 	{
	// 		this.setState({myBadges : false, earnedBadges : false, reqBadges : false,managePortfolio : false, portfolioVisitor : true});
	// 	}
	// }

    componentDidMount() {
       
    }
	
	render() {
        return (
            <Fragment>
                <Header></Header>
                	{/* <section className="dashboard-nav">
		                <div className="container">
		            	    <div className="head">
		            		    <h1>Portfolio</h1>
		            		</div>		            		
		            		<AccountNav></AccountNav>
		            	</div>
		            </section> */}
					<section className="portfolioDetails_v2 pt-md-15 pb-md-40 pb-20 pt-20 mt-4">
						<div className="container writer-container">
							<div className="row">
								<div className="col-md-3">    
									<div className="card custom">
								        <div className="card-header">
										    Portfolio
								    	</div>
								        <div className="card-body">
								    	    <nav className="custom-sidenav" id="myScrollspy">
								            	<ul className="list-group">	
								            		{/* <li className={this.state.managePortfolio ? `active`: null}><a to="#" onClick={() => this.handleMenu('managePortfolio')}>Settings</a></li>									
								            		<li className={this.state.myBadges ? `active`: null}><a to="#" onClick={() => this.handleMenu('myBadges')}>Badges</a></li>										
								            		<li className={this.state.portfolioVisitor ? `active`: null}><a to="#" onClick={() => this.handleMenu('portfolioVisitor')}>Visitors</a></li> */}

													<li className='active'><NavLink to={`/account/portfolio`} exact={true}>Settings</NavLink></li>
													{/* <li><NavLink to={`/account/portfolio/badges`} exact={true}>Badges</NavLink></li> */}
													<li><NavLink to={`/account/portfolio/visitors`} exact={true}>Visitors</NavLink></li>
								            		
								            	</ul>
								            </nav>
								    	</div>	
								    </div>
								</div>	
								<div className="col-md-9 mt-md-0 mt-4">
									{/* {this.state.managePortfolio ? <ProfileSettings></ProfileSettings> : null }
									{this.state.myBadges ? <WriterBadges></WriterBadges> : null }
									{this.state.portfolioVisitor ? <Visitors></Visitors> : null } */}
									<ProfileSettings></ProfileSettings>
								</div>
							</div>
						</div>
					</section>
            </Fragment>
        );
    }
}

Portfolio.contextType = AppContext;
export default Portfolio;



// WEBPACK FOOTER //
// ./src/components/writer/account/Portfolio.js